// AI-ASSISTED: generated with claude-code on 2026-08-26, reviewed by <dev>
//
// Flag-aware sidebar entry for /maintenance: renders the nav item only when
// the backend reports the `backstage-maintenance-view` flag is on (spec
// FR-001), so a disabled feature hides the tab entirely instead of linking
// to a 404. Mirrors modules/releases/ReleasesSidebarItem.tsx.
import useAsync from 'react-use/lib/useAsync';
import { SidebarItem } from '@backstage/core-components';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import BuildIcon from '@mui/icons-material/Build';
import { MaintenanceApiClient } from './MaintenanceApiClient';
import { COPY } from './maintenance.copy';

export const MaintenanceSidebarItem = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);

  const { value: enabled } = useAsync(async () => {
    const client = new MaintenanceApiClient({ discoveryApi, fetchApi });
    return client.enabled();
  }, [discoveryApi, fetchApi]);

  if (!enabled) return null;
  return <SidebarItem icon={BuildIcon} to="/maintenance" text={COPY.sidebar.label} />;
};
